<div *ngIf="election" [ngClass]="lgElectionService.isMobile ? 'first-pref-table-phone' :'first-pref-table'">
    <div class="result-header">
        <div *ngIf="isFinalResult===false" class="result-header-item">
            <b>First Preference Results for Election of {{election.electionName}}</b>
        </div>
        <div *ngIf="isFinalResult===true && isProvisional===true" class="result-header-item">
            <b>Provisional Results for Election of {{election.electionName}}</b>
        </div>
        <div *ngIf="isFinalResult===true && isProvisional===false" class="result-header-item">
            <b>Final Results for Election of {{election.electionName}}</b>
        </div>
        <div class="result-header-item">
            {{election.candidateCount}} candidate{{election.candidateCount===1?'':'s'}} 
            contesting {{election.vacancies}} vacanc{{election.vacancies===1?'y':'ies'}}
        </div>
        <div class="result-header-line">
            <div class="result-header-label">
                Formal ballot papers
            </div> 
            <div class="result-header-value">
                {{election.ballotPapersFormal | number}}
            </div> 
        </div>
        <div class="result-header-line">
            <div class="result-header-label">
                Informal ballot papers
            </div>
            <div class="result-header-value">
                {{election.ballotPapersInformal | number}}
            </div>
        </div>
        <div class="result-header-line">
            <div class="result-header-label">
                Election quota
            </div>
            <div class="result-header-value">
                {{election.quota | number}}
            </div>
        </div>
    </div>
    <div class="table-section">
        <table mat-table [dataSource]="dataSource" >
            <ng-container *ngFor="let col of columns; trackBy: customTrackBy; let i = index;" matColumnDef="{{col.column}}">
                <th mat-header-cell *matHeaderCellDef class="table-header"> 
                    <div *ngFor="let labelItem of col.labels">
                        <div [ngClass]="{'header-centre':labelItem!=='Candidates','header-left':labelItem==='Candidates'}">
                            {{labelItem}}
                        </div>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element" >
                    <div [style.min-width.px]="col.minWidth" 
                        [ngClass]="{'value-justify-right':col.isRightJustify===true, 'value-justify-left':col.isRightJustify===false}" >
                        {{element[col.column]}}
                    </div>
                </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
        </table>
    </div>
    <div *ngIf="isFinalResult===true" class="provisional-declaration">
        <div *ngIf="isProvisional===true">
            Provisional Declaration made at {{election.declarationDate | date:'h:mm a EEEE, MMMM d, y' }}
        </div>
        <div *ngIf="isProvisional===false">
            Final Results
        </div>
        
        <div *ngIf="election.scrutinySheetUrl&&election.scrutinySheetUrl!==''" class="scutiny-sheet-button">
            <div>
                <button mat-mini-fab 
                color="primary" 
                aria-label="Document"
                (click)="openScrutinySheet(election.scrutinySheetUrl);">
                <mat-icon>description</mat-icon>
            </button>
            </div>
            <div class="scrutiny-sheet-text">
                Scrutiny Sheet
            </div>
        </div>
    </div>
    <div class="bottom">

    </div>
</div>